module.exports = __webpack_public_path__ + "img/logo.5494ee76.png";